import Button from '../ui/Button.jsx'

function formatTimer(secs) {
  const h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60
  if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
  return `${m}:${String(s).padStart(2,'0')}`
}

export default function MicDock({ elapsedSecs, paused, onPauseToggle }) {
  const barColor = paused ? 'bg-muted/60' : 'bg-ink'
  const ringColor = paused ? 'border-muted/40' : 'border-terra-500'
  return (
    <div
      className="fixed inset-x-3 bottom-3 z-30 flex items-center gap-2.5 rounded-[18px] border border-line bg-white px-3 py-2.5 shadow-[0_12px_28px_rgba(13,13,13,.08)] sm:inset-x-6 sm:bottom-5"
      style={{ paddingBottom: 'max(0.625rem, env(safe-area-inset-bottom))' }}
    >
      <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-bg">
        <span className={`absolute -inset-1 rounded-full border-[1.5px] opacity-30 ${ringColor} ${!paused ? 'animate-ripple' : ''}`} />
        <div className="flex h-[18px] items-end gap-[2px]">
          <span className={`w-[3px] rounded-[1px] ${barColor}`} style={{ height: '55%' }} />
          <span className={`w-[3px] rounded-[1px] ${barColor}`} style={{ height: '90%' }} />
          <span className={`w-[3px] rounded-[1px] ${barColor}`} style={{ height: '45%' }} />
          <span className={`w-[3px] rounded-[1px] ${barColor}`} style={{ height: '75%' }} />
        </div>
      </div>
      <div className="min-w-0 flex-1">
        <div className={`text-[10.5px] ${paused ? 'font-semibold text-muted uppercase tracking-[.3px]' : 'text-muted'}`}>
          {paused ? 'En pause' : 'Enregistrement'}
        </div>
        <div className="text-[13px] font-semibold tabular-nums">{formatTimer(elapsedSecs)}</div>
      </div>
      <Button
        variant="primary"
        onClick={onPauseToggle}
        aria-label={paused ? 'Reprendre' : 'Pause'}
        className="h-11 w-11 justify-center p-0 text-[15px]"
      >
        {paused ? '▶' : '⏸'}
      </Button>
    </div>
  )
}
